export enum WidgetSettingsEventsKeys {
  TabChanged = 'tabChanged',
  InjectComponentDraft = 'injectComponentDraft',
  HideEvent = 'hideEvent',
  ReloadEvents = 'reloadEvents',
}
